import 'global.css'

import GitInfo from 'react-git-info/macro'

const GetBranchName = () => {
  const gitInfo = GitInfo()
  if (!gitInfo.branch || gitInfo.branch == 'master') {
    return null
  }
  return (
    <div className="text-xxs fixed bottom-0 left-0 z-1000 rounded-tr-md bg-black/50 p-1 text-slate-100">
      {gitInfo.branch}
    </div>
  )
}

export default GetBranchName
